'use client';

import classNames from 'classnames';
import { ReactNode } from 'react';
import { AnimatedNumber } from './AnimatedNumber';
import { Skeleton } from './Skeleton';

interface AnimatedNumbersSetProps {
  numbers: {
    title: string | ReactNode;
    number: number;
    prefix?: string;
    suffix?: string;
    footer?: ReactNode;
    itemPrefix?: ReactNode;
  }[];
  loading?: boolean;
  classes?: {
    container?: string;
    item?: string;
    itemTitle?: string;
    itemNumber?: string;
    itemContainer?: string;
  };
}

export const AnimatedNumbersSet = ({
  numbers,
  classes,
  loading = false,
}: AnimatedNumbersSetProps) => {
  return (
    <div
      className={classNames(
        'w-full grid grid-cols-2 lg:grid-cols-4 p-3 sm:p-6 items-center justify-between border border-gray-200 rounded-xl gap-2',
        classes?.container,
      )}
    >
      {numbers.map(({ title, number, prefix, suffix, footer, itemPrefix }, index) => {
        return (
          <div key={index} className={classes?.itemContainer}>
            {itemPrefix}
            <div
              className={classNames(
                'flex flex-col gap-2',
                { 'border-0 lg:border-l pl-0 lg:pl-6 border-gray-200': index !== 0 },
                classes?.item,
              )}
              key={index}
            >
              <div
                className={classNames(
                  'text-[14px] leading-[22px] text-gray-500',
                  {
                    'mt-2': !classes?.itemTitle?.includes('mt-'),
                  },
                  classes?.itemTitle,
                )}
              >
                {loading ? <Skeleton width="80%" height={14} /> : title !== undefined && title}
              </div>
              <div
                className={classNames(
                  'text-[24px] sm:text-[32px] leading-[30px] flex items-center',
                  classes?.itemNumber,
                )}
              >
                {loading ? (
                  <Skeleton width="40%" height={20} className="mt-1" />
                ) : (
                  number !== undefined && (
                    <>
                      {prefix && <p>{prefix}</p>}
                      {<AnimatedNumber includeComma animateToNumber={+number.toFixed(2)} />}
                      {suffix && <p>{suffix}</p>}
                    </>
                  )
                )}
              </div>
              {loading && footer !== undefined ? (
                <Skeleton width="20%" height={16} className="mt-1" />
              ) : (
                footer !== undefined && footer
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
